module.exports = __webpack_public_path__ + "img/blue-graph.df02da78.png";